import type { ReactElement, ReactNode } from "react"
import React from "react"
import _t from "@core/i18n"
import CalculatorButtonIcon from "@onestore-icons/calculator-button-icon.svg"
import SelectButtonAtm from "@onestore/hel/dist/components/atoms/SelectButtonAtm"
import OverlayContainerOrg, {
  headerTypes,
  sizes,
  startPositions,
} from "@onestore/hel/dist/components/organisms/OverlayContainerOrg"
import MarkdownTitle from "@gatsby-plugin-generic-page/components/Markdown/Title"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import useModalState from "~/hooks/useModalState"
import { sendCostCalculatorModalButtonClick } from "~/lib/analytics"

interface CostCalculatorModalButtonProps {
  costCalculatorElement: ReactNode
}

export function CostCalculatorModalButton({
  costCalculatorElement,
}: CostCalculatorModalButtonProps): ReactElement<CostCalculatorModalButtonProps> {
  const { isOpen, open, close } = useModalState()

  const handleOnClick = () => {
    open()
    sendCostCalculatorModalButtonClick()
  }

  return (
    <>
      <SelectButtonAtm
        title={_t("marketplace.calculatorButton")}
        backgroundColor="backgroundLightTint"
        onClick={handleOnClick}
        before={<CalculatorButtonIcon />}
      >
        {_t("marketplace.calculatorButton")}
      </SelectButtonAtm>

      {isOpen ? (
        <OverlayContainerOrg
          size={sizes.LARGE}
          startPosition={startPositions.RIGHT}
          headerType={headerTypes.SHADOWED}
          header={
            <MarkdownTitle
              overrides={getBaseMarkdownOverrides({
                typography: {
                  large: "large2",
                  medium: "large2",
                  small: "big2",
                },
              })}
            >
              {_t("marketplace.costCalculator")}
            </MarkdownTitle>
          }
          headerWidth="default"
          onCloseButtonClick={close}
        >
          {costCalculatorElement}
        </OverlayContainerOrg>
      ) : null}
    </>
  )
}
